@if (useClickableCardStyle()) {
  <mwe-basic-card-clickable class="col-12 col-md-6 pb-4 mh-100" [disabled]="!isClickable()" (cardClicked)="showProductDetails($event)">
    <mwe-product-icons [categories]="[product().category]" size="2xl" />
    <p class="mb-1 mt-1">
      {{ product() | translateTariffClass: null : (product().category | translateCategory) | async }}
    </p>
    <p class="text--legal mb-0">{{ product().category | correlatedCompanyReference }}</p>
    @if (unpaidInvoices()?.offeneZahlungen?.length) {
      <mwe-badge
        class="d-block mt-3"
        data-test="product-card-show-unpaid-invoices-btn"
        iconClass="fas fa-exclamation-triangle"
        type="danger"
        emphasis="bold"
        size="md"
        text="products.unpaidInvoices.duePayment"
      />
    }
    @if (hasContractEnded()) {
      <mwe-badge
        class="d-block mt-3"
        data-test="product-card-contract-ended"
        iconClass="fas fa-circle-exclamation"
        [type]="contractEndedBadgeTyp()"
        emphasis="bold"
        size="md"
        text="products.endedContract"
      />
    }
    @if (isActiveBadgeVisible()) {
      <mwe-badge
        class="d-block mt-3"
        data-test="product-card-contract-ended"
        iconClass="fas fa-circle-check"
        type="success"
        emphasis="bold"
        size="md"
        text="products.activeContract"
      />
    }
  </mwe-basic-card-clickable>
} @else {
  <div
    (click)="isClickable() ? showProductDetails($event) : false"
    class="card-basic mb-4"
    [ngClass]="{ 'has-notch': isClickable(), 'card-has-focus': buttonIsFocused }"
    [ngStyle]="{
      cursor: isClickable() ? 'pointer' : 'initial',
    }"
  >
    @if (isClickable()) {
      <button
        type="button"
        class="btn btn-bubble btn-primary button-in-notch card-focus-effect-trigger"
        [ngClass]="{ 'bg-gray-500 border-gray-500': iconExtendedStyle() === 'grau' }"
        (click)="showProductDetails($event)"
        [attr.title]="'products.toDetailPage' | translate: { product: product().category | translateCategory }"
        (focus)="buttonIsFocused = true"
        (blur)="buttonIsFocused = false"
      >
        <i class="fas fa-chevron-right"></i>
      </button>
      <div class="button-notch">
        <ng-container *ngTemplateOutlet="content" />
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="content" />
    }
  </div>
}

<ng-template #content>
  @if (!isDetailsState()) {
    <div class="card-basic-body text-center">
      <img alt="" src="/assets/icons/products/icon-{{ categoryIcon() }}.svg" width="75" />
      <h3 class="h6 font-size-16 mt-2 mb-0" data-test="product-category-text">
        {{ product().category | translateCategory }}
      </h3>
      @if (showCompanyCorrelation()) {
        <p class="text--legal mt-2 mb-0">
          {{ product().category | correlatedCompanyReference }}
        </p>
      }
    </div>
  } @else {
    <div class="card-basic-body">
      <div class="row gx-4 align-items-center">
        <div class="col-auto text-center">
          <img alt src="/assets/icons/products/icon-{{ categoryIcon }}.svg" width="75" />
          <h3 class="h6 font-size-16 mt-2 mb-0" data-test="product-category-text">{{ product().category | translateCategory }}</h3>
        </div>
        <div class="col">
          @if (onlineNotPossibleWarningLabel) {
            <p [translate]="onlineNotPossibleWarningLabel"></p>
          } @else {
            <h4 class="h5">{{ product() | translateTariffClass: null : (product().category | translateCategory) }}</h4>
            @if (showCompanyCorrelation()) {
              <p class="text--legal">
                {{ product().category | correlatedCompanyReference }}
              </p>
            }
          }
        </div>
      </div>
    </div>
    @if (isActive()) {
      <div class="card-basic-body card-basic-body-slim bg-gray-500" data-test="products-card-inactive-info">
        <p class="text--large text-white mb-0" translate="products.card.inactive"></p>
      </div>
    }
    @if (unpaidInvoices()?.offeneZahlungen?.length) {
      <div class="card-basic-body border-top py-2" data-test="product-card-show-unpaid-invoices-btn">
        <img alt class="align-text-bottom mr-2" src="assets/icons/icon-warning.svg" width="22" />
        <span class="text-danger text--extra-large fw-semibold" translate="products.unpaidInvoices.duePayment"></span>
      </div>
    }
  }
</ng-template>
